'use client';

import { ArrowLeft } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useTransition } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { resetPassword } from '@/core/authorizations/server/actions/reset-password';
export const ForgotPasswordForm = () => {
  const [isPending, startTransition] = useTransition();
  const handleFormSubmit = async (formData: FormData) => {
    startTransition(async () => {
      const {
        success,
        message
      } = await resetPassword(formData);
      if (success === true) {
        toast.success(message);
      } else {
        toast.error(message);
      }
    });
  };
  return <Card className="w-full" data-sentry-element="Card" data-sentry-component="ForgotPasswordForm" data-sentry-source-file="forgot-password-form.tsx">
      <CardHeader data-sentry-element="CardHeader" data-sentry-source-file="forgot-password-form.tsx">
        <div className="flex w-full justify-center">
          <Image src="/logo-text.svg" width={148} height={41} alt="enrise logo" className="h-auto w-32 sm:w-40" priority data-sentry-element="Image" data-sentry-source-file="forgot-password-form.tsx" />
        </div>
      </CardHeader>
      <CardContent data-sentry-element="CardContent" data-sentry-source-file="forgot-password-form.tsx">
        <form action={handleFormSubmit} className="space-y-6">
          <h1 className="text-center text-xl font-semibold tracking-tight sm:text-2xl">
            Mot de passe oublié
          </h1>
          <Input id="email" placeholder="Entrer votre email" required name="email" type="email" className="w-full" data-sentry-element="Input" data-sentry-source-file="forgot-password-form.tsx" />
          <Button type="submit" variant="primary" className="w-full" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="forgot-password-form.tsx">
            {isPending && <Spinner />}
            Réinitialiser
          </Button>
          <Link href="/auth/login" className="flex items-center justify-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary" data-sentry-element="Link" data-sentry-source-file="forgot-password-form.tsx">
            <ArrowLeft className="size-4" data-sentry-element="ArrowLeft" data-sentry-source-file="forgot-password-form.tsx" />
            Retour à la page de connexion
          </Link>
        </form>
      </CardContent>
    </Card>;
};